<template>
<div class="requests-table">
  <!-- BEGIN FLOAT HEAD TABLE -->
  <div v-if="customer" class="table-toolbar">

      <button @click="download" class="btn btn-icon"><i class="fa fa-download"></i></button>

      <!-- <FormulateInput v-model="query"" type="text" placeholder="Enter a search term..." />
           <button type="submit" class="btn btn-icon"><i class="fa fa-search"></i></button> -->
  </div>
  <transition name="fade">
    <div id="wrapper" class='wrapper small'>
      <div class="table-responsive">
        <table class="table table-bordered table-hover table-striped contacts-queue-table">
          <thead>
            <tr>
              <th></th>
              <th v-for="(item, $index) in headerRow">
                {{ item }}
              </th>
              <th v-for="field in lead_fields">
                {{ field.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.id">
              <td class="text-center">
                <button class="btn btn-link" v-on:click="showDetails(row.id)">
                  <i class="fa fa-info" style="padding-right: 0"></i>
                </button>
              </td>
              <td>{{ row.created | formatTimestamp }}</td>
              <td>{{ row.customer }}</td>
              <td>{{ row.campaign }}</td>
              <td>{{ row.status | uppercase }}</td>
              <td>{{ row.billing_status | uppercase }}</td>
              <td>{{ row.errors | join(', ') }}</td>
              <td><i class="fa fa-lg fa-check" v-if="row.is_sale"></i></td>
              <td v-for="f in lead_fields">{{ row.lead_fields[f.slug] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ls-table-pagination">
        <button class="btn btn-primary" :disabled="previous == 0" @click="page--"><i class="fa fa-arrow-left"></i> prev</button> |
        <button class="btn btn-primary" :disabled="next == 0" @click="page++">next <i class="fa fa-arrow-right"></i></button>
      </div>
    </div>
  </transition>
  <!-- END ENDLESS TABLE -->

  <!-- BEGIN LEAD DETAIL -->
  <request-data-modal v-if="requestRecord"
                      v-bind:request-data="requestRecord"
                      v-on:close="requestRecord = null">
  </request-data-modal>
  <!-- END LEAD DETAIL -->
</div>
</template>

<script>

 // http://mkoryak.github.io/floatThead/#examples

 import Vue from 'vue';
 import RequestDataModal from 'components/modals/RequestDataModal';

 export default {
   name: 'requeststable',
   props: {
     datesRange: Object,
     header: Object,
     customer: String,
       campaign: String,
   },
   components: {
     'request-data-modal': RequestDataModal
   },
   created() {
     // this.setQueryFields(this.pickedColumns);
     if (this.header) {
       this.headerRow = this.header;
     }
     BUS.$on('refreshRequests', this.fetch, true);
   },
   data () {
     return {
       table: {},
       orderBy: null,
       orderAsc: false,
       page: 1,
       next: 0,
       previous: 0,
       rows: [],
       lead_fields: [],
       headerRow: ["Created", "Customer", "Campaign", "Status", "Billing Status", "Errors", "Conversion"],
       requestRecord: null,
       query: ""
     };
   },
   computed: {
     $table () {
       return $('table.contacts-queue-table');
     }
   },
   watch: {
     datesRange: function () {
       this.fetch();
     },
     page: function () {
       this.fetch(this.page);
     },
     customer: function () {
       this.fetch();
     },
     campaign: function () {
       this.fetch();
     },
   },
     mounted () {
         this.fetch();
   },
   methods: {
     populateRows (rowsArr) {
       this.rows = [];
       for (var index in rowsArr) {
	       var row = rowsArr[index];
	       var obj = this.populateRow(row);
	       var populated = jQuery.extend(true, {}, obj);
	       this.rows.push(populated);
       }
     },
     parseErrors(errors) {
       var codes = [];
       errors.forEach(function (item) {
         codes.push(item.code);
       });
       return codes;
     },
     handleResponse(response) {
       var self = this;

       if ('lead_fields' in response.data) {
         self.lead_fields = response.data.lead_fields;
       }
       else {
         self.lead_fields = [];
       }

       self.populateRows(response.data.results);

       var counts = {
         total: response.data.count,
         ok: response.data.count_ok,
         error: response.data.count_error,
         test: response.data.count_test,
         sales: response.data.count_sales,
         count_by_campaign: response.data.count_by_campaign,
         chart_by_campaign: response.data.chart_by_campaign,
           available_campaigns: response.data.available_campaigns || [],
         customer: null
       }

       if ('customer' in response.data) {
         counts['customer'] = response.data.customer;
       }

       if (response.data.next !== null) {
         self.next = self.page + 1;
       }
       else {
         self.next = 0;
       }

       if (response.data.previous !== null) {
         self.previous = self.page - 1;
       }
       else {
         self.previous = 0;
       }
       self.$emit('loaded', counts);
     },
     populateRow (row) {
       var r = {};
       r.id = row.id;
       r.created = row.created;
       r.customer = row.campaign.customer;
       r.campaign = row.campaign.name;
       r.status = row.status;
       r.billing_status = row.billing_status;
       r.errors = this.parseErrors(row.errors);
       r.is_sale = row.is_sale;

       r.lead_fields = {};

       this.lead_fields.forEach(function (item) {
         r.lead_fields[item.slug] = row.lead_fields[item.slug] ? row.lead_fields[item.slug] : '';
       });

       return r;
     },
     fetchNext: _.debounce(function () {
       this.fetch(this.next);
     }),
     fetchPrev: _.debounce(function () {
       this.fetch(this.prev);
     }),
     fetch: _.debounce(function (nextPage) {
       var req = {
         page: 1
       }

       if (typeof nextPage !== "undefined") {
         req['page'] = nextPage;
       }

       if (this.query) {
         req['q'] = this.query;
       }

       if (this.datesRange['from']) {
         req['from_date'] = this.datesRange['from'];
       }

       if (this.datesRange['to']) {
         req['to_date'] = this.datesRange['to'];
       }

       if (this.campaign) {
           req['campaign'] = this.campaign;
       }

       var self = this;

       var promise = null;
       if (self.customer) {
         promise = API.requests.getLeads(self.customer, req);
       }
       else {
         promise = API.requests.getList(req);
       }
       promise.then(function (response) {
         self.page = req.page;
         self.handleResponse(response);
	 //self.isLoading = false;
       }, self.onErrorCallback);
     }, 50),
     showDetails(id) {
       var self = this;
       API.requests.getItem(id)
	  .then(function (response) {
	    self.requestRecord = response.body;
	  });
     },
     download: _.debounce(function () {
       var req= {};
       var self = this;

       if (this.datesRange['from']) {
         req['from_date'] = this.datesRange['from'];
       }

       if (this.datesRange['to']) {
         req['to_date'] = this.datesRange['to'];
       }

       if (this.campaign) {
           req['campaign'] = this.campaign;
       }

      API.requests.download(self.customer, req);

     }, 100),
   }
 };
</script>

<style lang="scss">
 .requests-table {
   border-radius: 4px;
   padding: 10px;

   th, .th {
     background: #f38c3d;
     color: #fff;
   }

   td {
     white-space: nowrap;
   }

   td>.btn {
     text-align: center;
     padding: 0px 6px;
   }

   .wrapper {
     position: relative;
   }

   .wrapper.small {
     height: 100%;
     width: 100%;
   }
   .not-visible {
     visibility: hidden;
   }

   tr.not-visible,
   tr.not-visible td {
     padding: 0 !important;
     height: 0 !important;
     line-height: 0 !important;
   }

   tr.not-visible td div {
     display: inline-block;
     white-space: nowrap;
     margin-right: 42px;
     font-weight: 500;
     font-size: 16px;
     line-height: 0;
   }
 }
 /**

    .table-toolbar {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 6px 4px;
    background-color: #adadad;

    form {
    > * {
    display: inline-block;
    }

    .formulate-input {
    margin-bottom: 0px;

    input {
    background: #efefef;
    width: 100%!important;

    &:focus {
    background: #fff;
    }
    }
    }
    }
    }


    table.leads-queue-table {
    font-family: 'Roboto Mono','Inconsolata', monospace;
    }
  */



</style>



// WEBPACK FOOTER //
// RequestsTable.vue?21954bfb